

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.timeline-slider');

  containers.forEach(container => {
    const intervalTime = (parseInt(container.dataset.autoplayInterval) || 5000) * 0.7;
    // We will query items dynamically because their location changes in DOM
    let items = container.querySelectorAll('.timeline-slider__item');
    const images = container.querySelectorAll('.timeline-slider__image-wrapper');
    const leftCol = container.querySelector('.timeline-slider__col--left');
    const rightCol = container.querySelector('.timeline-slider__col--right');
    const layout = container.querySelector('.timeline-slider__layout');
    const centerCol = container.querySelector('.timeline-slider__col--center');

    const totalSteps = items.length; /* items node list is static in length usually, but let's be careful if we re-query */
    if (totalSteps === 0) return;

    let currentIndex = 0;
    let autoplayTimer = null;
    let isPaused = false;
    let isAutoplayDisabled = false;
    let subImageIndex = 0;
    let isMobileLayout = false;
    let isInitialLoad = true;
    let isProgrammaticScroll = false;
    let programmaticScrollTimeout = null;

    // Mobile Scroll Observer
    let mobileObserver = null;

    const initMobileObserver = () => {
      if (mobileObserver) mobileObserver.disconnect();
      const mobileWrapper = container.querySelector('.timeline-slider__mobile-items-wrapper');
      if (!mobileWrapper) return;

      mobileObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Calculate which item is most visible if needed, but with threshold 0.6 usually one.
            // Or just set active when it crosses threshold.
            const index = parseInt(entry.target.dataset.index);
            if (index !== currentIndex) {
              // Pass true for fromScroll to avoid scrolling it back
              setActiveStep(index, true);
              // We should also pause/restart autoplay on scroll interaction?
              // Rely on click/touch listeners for pause, but successful scroll means user is interacting.
              stopAutoplay();
              startAutoplay();
            }
          }
        });
      }, {
        root: mobileWrapper,
        threshold: 0.6
      });

      mobileWrapper.querySelectorAll('.timeline-slider__item').forEach(item => {
        mobileObserver.observe(item);
      });
    };

    // --- Responsive Layout Logic ---

    const initMobileLayout = () => {
      if (isMobileLayout) return;
      isMobileLayout = true;

      // Create wrapper if it doesn't exist
      let mobileWrapper = container.querySelector('.timeline-slider__mobile-items-wrapper');
      if (!mobileWrapper) {
        mobileWrapper = document.createElement('div');
        mobileWrapper.classList.add('timeline-slider__mobile-items-wrapper');
        // Insert after center column (which has the images)
        layout.insertBefore(mobileWrapper, centerCol.nextSibling);

        // --- Custom Scrollbar Logic ---
        const customScrollbar = document.createElement('div');
        customScrollbar.className = 'timeline-slider__custom-scrollbar';
        const thumb = document.createElement('div');
        thumb.className = 'timeline-slider__custom-scroll-thumb';
        customScrollbar.appendChild(thumb);
        layout.insertBefore(customScrollbar, mobileWrapper.nextSibling);

        const updateScrollbar = () => {
          const scrollWidth = mobileWrapper.scrollWidth;
          const clientWidth = mobileWrapper.clientWidth;
          const scrollLeft = mobileWrapper.scrollLeft;

          if (scrollWidth <= clientWidth) {
            thumb.style.width = '100%';
            thumb.style.left = '0';
          } else {
            // Calculate thumb width proportional to view
            const thumbWidth = (clientWidth / scrollWidth) * 100;
            thumb.style.width = `${thumbWidth}%`;

            // Calculate thumb position
            const maxScrollLeft = scrollWidth - clientWidth;
            const percentage = scrollLeft / maxScrollLeft;
            // We can use percentage of the clear track (100% - thumbWidth)
            // or just left percentage if width is %.
            // Let's use left % for simplicity but we need to account for thumb width
            // actually left can be: (scrollLeft / scrollWidth) * 100 -> this is straight mapping

            // Better: left in % = (scrollLeft / maxScrollLeft) * (100 - thumbWidth)
            const left = percentage * (100 - thumbWidth);
            thumb.style.left = `${left}%`;
          }
        };

        mobileWrapper.addEventListener('scroll', () => {
          updateScrollbar();

          // Existing scroll logic
          isPaused = true;
          if (!isProgrammaticScroll) {
            isAutoplayDisabled = true;
          }
          clearTimeout(autoplayTimer);

          if (mobileWrapper.scrollResumeTimer) clearTimeout(mobileWrapper.scrollResumeTimer);
          mobileWrapper.scrollResumeTimer = setTimeout(() => {
            isPaused = false;
            startAutoplay();
          }, 500);
        }, { passive: true });

        // Initial and Resize updates
        window.addEventListener('resize', updateScrollbar);
        // Observer to update when content changes/loads
        new ResizeObserver(updateScrollbar).observe(mobileWrapper);
        setTimeout(updateScrollbar, 200);

        // Allow dragging scrollbar
        let isDragging = false;
        let startX;
        let startScrollLeft;

        customScrollbar.addEventListener('touchstart', (e) => {
          const touch = e.touches[0];
          const rect = customScrollbar.getBoundingClientRect();
          const clickX = touch.clientX - rect.left;
          const thumbWidthPx = thumb.offsetWidth;
          const currentThumbLeftPx = thumb.offsetLeft;

          // If clicked on track (not thumb), scroll there
          // If clicked on thumb, start drag (though native scrolling is better usually)
        });

        // Simple click to scroll on track
        customScrollbar.addEventListener('click', (e) => {
          if (e.target === thumb) return;
          const rect = customScrollbar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const trackWidth = rect.width;

          const scrollWidth = mobileWrapper.scrollWidth;
          const clientWidth = mobileWrapper.clientWidth;
          const maxScrollLeft = scrollWidth - clientWidth;

          const ratio = clickX / trackWidth;
          mobileWrapper.scrollTo({
            left: ratio * maxScrollLeft,
            behavior: 'smooth'
          });
        });
      }

      // Move all items to mobile wrapper. 
      // We know items 0,1 are in leftCol and 2,3 are in rightCol usually.
      // But we can just grab all .timeline-slider__item from anywhere in container
      const allItems = container.querySelectorAll('.timeline-slider__item');
      // Sort them by index just in case
      const sortedItems = Array.from(allItems).sort((a, b) => {
        return parseInt(a.dataset.index) - parseInt(b.dataset.index);
      });

      sortedItems.forEach(item => {
        mobileWrapper.appendChild(item);
      });

      // Initialize Observer after moves
      setTimeout(initMobileObserver, 100);
    };

    const initDesktopLayout = () => {
      if (!isMobileLayout) return;
      isMobileLayout = false;

      if (mobileObserver) mobileObserver.disconnect();

      const mobileWrapper = container.querySelector('.timeline-slider__mobile-items-wrapper');
      if (!mobileWrapper) return;

      const allItems = mobileWrapper.querySelectorAll('.timeline-slider__item');

      // Left Column: index 0 then 1
      const item0 = Array.from(allItems).find(i => parseInt(i.dataset.index) === 0);
      const item1 = Array.from(allItems).find(i => parseInt(i.dataset.index) === 1);
      if (item0 && leftCol) leftCol.appendChild(item0);
      if (item1 && leftCol) leftCol.appendChild(item1);

      // Right Column: index 3 then 2 (Item 4 before Item 3 in original structure)
      const item2 = Array.from(allItems).find(i => parseInt(i.dataset.index) === 2);
      const item3 = Array.from(allItems).find(i => parseInt(i.dataset.index) === 3);
      if (item3 && rightCol) rightCol.appendChild(item3);
      if (item2 && rightCol) rightCol.appendChild(item2);

      // Ensure proper order in columns if needed (append puts at end)
      // Since we iterate 0..3, 0 goes to left, then 1 goes to left (end), matches structure.
      // 2 goes right, 3 goes right (end), matches structure.
    };

    const checkLayout = () => {
      if (window.innerWidth <= 992) {
        initMobileLayout();
      } else {
        initDesktopLayout();
      }
      // Re-query items in case refs were lost or weird (though DOM elements persist)
      items = container.querySelectorAll('.timeline-slider__item');
    };

    // Initial check
    checkLayout();

    // Resize listener
    window.addEventListener('resize', () => {
      checkLayout();
    });

    // --- End Responsive Layout Logic ---


    const getSubImages = (stepIndex) => {
      if (stepIndex !== 0) return [];
      const step0Img = images[0];
      if (!step0Img) return [];
      return Array.from(step0Img.querySelectorAll('.timeline-slider__sub-image-wrapper'));
    };

    const resetSubImages = () => {
      const subs = getSubImages(0);
      subs.forEach(sub => sub.classList.remove('fly-in'));
      subImageIndex = 0;
    };

    const getPaws = (pathElements, sortBy = 'x') => {
      const paths = Array.from(pathElements);
      const paws = [];
      for (let i = 0; i < paths.length; i += 5) {
        paws.push(paths.slice(i, i + 5));
      }
      // Pre-sort paws visually
      paws.sort((a, b) => {
        const getPos = (group) => {
          let sum = 0;
          group.forEach(path => {
            const bbox = path.getBBox();
            sum += (sortBy === 'x' ? bbox.x : bbox.y);
          });
          return sum / 5;
        };
        return getPos(a) - getPos(b);
      });
      return paws;
    };

    const centerBgPaws = getPaws(container.querySelectorAll('.timeline-slider__center-bg path'), 'x');
    const localPawsMap = new Map();
    container.querySelectorAll('.timeline-slider__item').forEach(item => {
      const idx = item.dataset.index;
      let paws = getPaws(item.querySelectorAll('.timeline-slider__path-bg path'), 'y');
      if (idx === "3") paws.reverse(); // Second local path (Item 4) fills in reverse visual order
      localPawsMap.set(idx, paws);
    });

    let progressRAF = null;
    let transitionStartedAt = 0;
    const transitionDuration = 980; // (1400 * 0.7)

    const resetFills = () => {
      container.querySelectorAll('.timeline-slider__path-bg path, .timeline-slider__center-bg path').forEach(p => p.style.fill = '');
    };

    const updateSvgFills = (index, progress) => {
      // 1. Local Paws (path-bg)
      const localPaws1 = localPawsMap.get("0");
      const localPaws4 = localPawsMap.get("3");

      if (index === 0) { // Step 1: Animate Path 1
        if (localPaws1) {
          localPaws1.forEach((paw, i) => {
            const isFilled = progress >= (i / localPaws1.length);
            paw.forEach(p => p.style.fill = isFilled ? '#EF4123' : p.style.fill);
          });
        }
      } else if (index === 3) { // Step 4: Animate Path 4
        if (localPaws4) {
          localPaws4.forEach((paw, i) => {
            const isFilled = progress >= (i / localPaws4.length);
            paw.forEach(p => p.style.fill = isFilled ? '#EF4123' : p.style.fill);
          });
        }
      }

      // Ensure previous local paths stay filled
      if (index > 0 && localPaws1) localPaws1.forEach(paw => paw.forEach(p => p.style.fill = '#EF4123'));
      if (index > 3 && localPaws4) localPaws4.forEach(paw => paw.forEach(p => p.style.fill = '#EF4123'));


      // 2. Center Trail
      const midPoint = Math.floor(centerBgPaws.length / 2);
      const firstHalf = centerBgPaws.slice(0, midPoint);
      const secondHalf = centerBgPaws.slice(midPoint);

      if (index === 1) { // Step 2: First half of center
        firstHalf.forEach((paw, i) => {
          const isFilled = progress >= (i / firstHalf.length);
          paw.forEach(p => p.style.fill = isFilled ? '#EF4123' : p.style.fill);
        });
      } else if (index === 2) { // Step 3: Second half of center
        secondHalf.forEach((paw, i) => {
          const isFilled = progress >= (i / secondHalf.length);
          paw.forEach(p => p.style.fill = isFilled ? '#EF4123' : p.style.fill);
        });
      }

      // Persistence for center segments
      if (index > 1) firstHalf.forEach(paw => paw.forEach(p => p.style.fill = '#EF4123'));
      if (index > 2) secondHalf.forEach(paw => paw.forEach(p => p.style.fill = '#EF4123'));
    };

    const runProgressLoop = () => {
      const now = Date.now();
      const elapsed = now - transitionStartedAt;
      const progress = Math.min(elapsed / transitionDuration, 1);

      updateSvgFills(currentIndex, progress);

      if (progress < 1) {
        progressRAF = requestAnimationFrame(runProgressLoop);
      } else {
        progressRAF = null;
      }
    };

    const setActiveStep = (index, fromScroll = false, skipImageAnim = false, skipSubImageReset = false) => {
      currentIndex = index; // Update index FIRST to avoid race conditions

      // Logic for Step 0 Sub-sequence Reset or Trigger
      if (index === 0) {
        resetSubImages();
        // Trigger fly-in immediately on manual switch to Step 1
        const subs = getSubImages(0);
        if (subs.length > 0) {
          setTimeout(() => {
            subs.forEach(sub => sub.classList.add('fly-in'));
          }, 50);
        }
      } else {
        if (!skipSubImageReset) {
          resetSubImages();
        }
      }

      resetFills();
      updateSvgFills(index, 0); // Instant initial update

      transitionStartedAt = Date.now();
      // Always restart animation loop for the new step
      if (progressRAF) {
        cancelAnimationFrame(progressRAF);
      }
      progressRAF = requestAnimationFrame(runProgressLoop);

      // Re-query items valid for current layout
      items = container.querySelectorAll('.timeline-slider__item');

      items.forEach(item => {
        const itemIndex = parseInt(item.dataset.index);
        if (itemIndex === index) {
          item.classList.add('active');
          const btn = item.querySelector('button');
          if (btn) btn.setAttribute('aria-current', 'step');

          if (isMobileLayout && !fromScroll && !isInitialLoad) {
            isProgrammaticScroll = true;

            const mobileWrapper = container.querySelector('.timeline-slider__mobile-items-wrapper');
            if (mobileWrapper && index === 0) {
              // Force disable smooth scroll on container for restart
              mobileWrapper.style.scrollBehavior = 'auto';
              item.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
              // Restore after scroll (small delay to ensure it took effect)
              setTimeout(() => {
                mobileWrapper.style.scrollBehavior = '';
              }, 50);
            } else {
              item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }

            if (programmaticScrollTimeout) clearTimeout(programmaticScrollTimeout);
            programmaticScrollTimeout = setTimeout(() => {
              isProgrammaticScroll = false;
            }, 1000);
          }
        } else {
          item.classList.remove('active');
          const btn = item.querySelector('button');
          if (btn) btn.removeAttribute('aria-current');
        }
      });

      images.forEach(img => {
        // Clear custom zoom class if present
        img.classList.remove('zoom-enter');

        const mainImg = img.querySelector('.timeline-slider__main-img');
        const imgIndex = parseInt(img.dataset.index);

        if (imgIndex === index) {
          // ACTIVE ITEM
          img.classList.add('active');

          // Ensure any manual overrides are cleared so it shows
          img.style.opacity = '';
          img.style.zIndex = '';
          img.style.display = ''; // Reset display on wrapper just in case

          if (mainImg) {
            mainImg.style.opacity = '';
            mainImg.style.display = ''; // Reset display on main image
          }

          if (mainImg) {
            if (!skipImageAnim) {
              mainImg.classList.remove('anim-jump');
              void mainImg.offsetWidth; // Force Reflow
              mainImg.classList.add('anim-jump');
            } else {
              // Remove animation class if we are skipping, to prevent re-trigger
              mainImg.classList.remove('anim-jump');
            }
          }
        } else {
          // INACTIVE ITEM
          img.classList.remove('active');

          // Reset wrapper opacity so it fades out (if it was forced to 1)
          img.style.opacity = '';
          img.style.zIndex = '';

          // IMPORTANT: If Main Image was manually hidden (opacity: 0), KEEP IT HIDDEN while wrapper fades.
          // Do NOT reset mainImg.style.opacity if it is set. 
          // It will be reset when this item becomes active again.
          // However, we DO need to remove 'anim-jump'.
          if (mainImg) {
            mainImg.classList.remove('anim-jump');
          }
        }
      });
    };

    const tick = () => {
      if (isPaused || isAutoplayDisabled) {
        if (isPaused) autoplayTimer = setTimeout(tick, 100);
        return;
      }

      // Logic for Step 0 Sub-sequence
      if (currentIndex === 0) {
        const subs = getSubImages(0);
        if (subs.length > 0) {
          if (subImageIndex === 0) {
            // Stage 1: Trigger Firework Fly-in
            subs.forEach(sub => sub.classList.add('fly-in'));
            subImageIndex = 1;

            // Wait ~1.75s (2500 * 0.7) for user to see them
            autoplayTimer = setTimeout(tick, 1750);
            return;
          } else if (subImageIndex === 1) {
            // Stage 2: Step 2 Appearance -> Pause -> Retract
            subImageIndex = 2;

            // IMMEDIATE: Switch to Step 2 State
            // 1. Activate Step 2 (Markers, Texts) via standard logic
            // skipImageAnim=true (we handle zoom), skipSubImageReset=true (we defer retraction)
            setActiveStep(1, false, true, true);

            // 2. Force Step 0 Wrapper to stay visible (opacity 1, z-index high)
            const prevWrapper = container.querySelector('.timeline-slider__image-wrapper[data-index="0"]');
            if (prevWrapper) {
              prevWrapper.style.opacity = '1';
              prevWrapper.style.zIndex = '5';
            }

            // 3. Hide Step 0 MAIN IMAGE specifically
            const prevMainImg = prevWrapper ? prevWrapper.querySelector('.timeline-slider__main-img') : null;
            if (prevMainImg) {
              prevMainImg.style.opacity = '0';
              prevMainImg.style.display = 'none'; // Force hide to prevent flash
            }

            // 4. Set Step 2 Image to Zoom Entry State (1.1)
            const nextWrapper = container.querySelector('.timeline-slider__image-wrapper[data-index="1"]');
            if (nextWrapper) {
              // Ensure transition is ready but we don't trigger it yet
              nextWrapper.style.transition = 'transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.8s ease';
              nextWrapper.classList.add('zoom-enter');
              void nextWrapper.offsetWidth; // Force Reflow
            }

            // 5. SIMULTANEOUS TRANSITION (Appearance + Retraction)

            // PHASE 1: TRIGGER RETRACTION IMMEDIATELY
            // Sub-images start retracting as soon as Step 2 appears (Zoomed)
            subs.forEach(sub => sub.classList.remove('fly-in'));

            // PHASE 2: PAUSE BEFORE ZOOM DOWN
            // We want Step 2 to stay at 1.1 (Zoomed) while retraction happens.
            // Retraction takes ~0.8s. 
            // We wait slightly longer (e.g. 1000ms) to let retraction finish and hold the zoomed state briefly.
            autoplayTimer = setTimeout(() => {

              // TRIGGER ZOOM DOWN (1.1 -> 1.0)
              if (nextWrapper) {
                nextWrapper.classList.remove('zoom-enter');
              }

              // Wait for Zoom Down transition (0.8s) then cleanup
              autoplayTimer = setTimeout(() => {
                // Cleanup Step 0
                if (prevWrapper) {
                  prevWrapper.style.opacity = '';
                  prevWrapper.style.zIndex = '';
                }
                /* 
                   Do NOT reset prevMainImg here. 
                   Resetting it causes it to pop into view (display:block) while the wrapper is fading out.
                   It will be reset automatically by setActiveStep when it becomes active again.
                */

                // Cleanup Step 2
                if (nextWrapper) {
                  nextWrapper.style.transition = '';
                  nextWrapper.classList.remove('zoom-enter');
                }

                // Schedule next normal tick
                autoplayTimer = setTimeout(tick, intervalTime);

              }, 500);

            }, 500); // 1.0s Pause (Retraction covers most of this)

            return;
          } else {
            // Stage 3: Done
          }
        }
      }

      // Standard Step Switch
      let nextIndex = currentIndex + 1;
      if (nextIndex >= totalSteps) nextIndex = 0;
      setActiveStep(nextIndex);

      let nextDelay = intervalTime;
      if (nextIndex === 0) {
        nextDelay = 200; // Fast trigger for Step 0 animation
      }
      autoplayTimer = setTimeout(tick, nextDelay);
    };

    const startAutoplay = () => {
      if (isAutoplayDisabled) return;
      if (autoplayTimer) clearTimeout(autoplayTimer);
      let delay = intervalTime;
      if (currentIndex === 0 && subImageIndex === 0) {
        delay = 200;
      }
      autoplayTimer = setTimeout(tick, delay);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
      if (progressRAF) {
        cancelAnimationFrame(progressRAF);
        progressRAF = null;
      }
    };

    // Interaction delegation or re-attachment? 
    // Since items move in DOM, listeners attached to elements *should* persist.
    // Let's verify. Yes, direct addEventListener on elements persists moves.
    container.querySelectorAll('.timeline-slider__item').forEach(item => {
      item.addEventListener('click', () => {
        isAutoplayDisabled = true;
        const index = parseInt(item.dataset.index);
        setActiveStep(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    // Initial 
    // setActiveStep(0); // This is called in tick or logically we start at 0. 
    // Just ensure correct state
    setActiveStep(0);
    setTimeout(() => {
      isInitialLoad = false;
    }, 100);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isAutoplayDisabled) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(container);
  });
});